import classNames from 'classnames';
import { handleNavigationClick } from 'helpers/app.helper';
import { onKeyDownHandler } from 'helpers/ui.helper';
var iconSize = 77;
var renderNavItem = function (item) {
    var title = item.title, icon = item.icon, description = item.description, isDisable = item.isDisable, disabledDescription = item.disabledDescription, onClick = item.onClick;
    return (<div key={title} role="button" tabIndex={0} onClick={function () { return handleNavigationClick(isDisable, onClick); }} onKeyDown={function (evt) { return onKeyDownHandler(evt, handleNavigationClick(isDisable, onClick)); }} className="c-had-navigator-modal__nav-item">
      <div>
        <svg preserveAspectRatio="xMidYMid meet" width={iconSize} height={iconSize}>
          <use xlinkHref={"#".concat(icon).concat(isDisable ? '--disabled' : '')}/>
        </svg>
      </div>
      <div className="c-had-navigator-modal__nav-item-text">
        <div className={classNames({ 'u-els-color-n10': isDisable }, 'c-had-navigator-modal__nav-item-text--title')}>{title}</div>
        <div className={classNames({ 'u-els-color-n6': isDisable }, 'c-had-navigator-modal__nav-item-text--description')}>{isDisable ? disabledDescription : description}</div>
      </div>
    </div>);
};
export { renderNavItem };
